import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFedopsLogger } from '../Hoc/Fedops/FedopsProvider';
import { InteractionName } from '../../types/InteractionName';
import { isVerticallyCollapsed, selectOnClick, selectTopProps } from '../../selectors';
import { expandWidget } from '../../actions/expandWidget';
import { PaymentMethodsListView } from './view';
import { useOnPaymentMethodsAmountInit } from './useOnPaymentMethodsAmountInit';
import { useBI } from './hooks/useBI';

export function PaymentMethodsListController() {
  const { layout, onPaymentAuthorizedInit, onPaymentAuthorized, onShippingContactSelected } =
    useSelector(selectTopProps);
  const onClick = useSelector(selectOnClick);
  const dispatch = useDispatch();
  const fedopsLogger = useFedopsLogger();
  const isCollapsed = useSelector(isVerticallyCollapsed);
  const bi = useBI();

  const onMorePaymentOptionsClick = useCallback(() => {
    bi.reportMoreOptionsClicked();
    dispatch(expandWidget());
  }, [bi, dispatch]);

  useOnPaymentMethodsAmountInit();

  useEffect(() => {
    fedopsLogger.interactionEnded(InteractionName.FMP);
    fedopsLogger.appLoaded();
    bi.reportLoaded();
  }, []);

  return (
    <PaymentMethodsListView
      isCollapsed={isCollapsed}
      layout={layout}
      onClick={onClick}
      onExpand={onMorePaymentOptionsClick}
      onPaymentAuthorized={onPaymentAuthorized}
      onPaymentAuthorizedInit={onPaymentAuthorizedInit}
      onShippingContactSelected={onShippingContactSelected}
    />
  );
}
